module.exports = __webpack_public_path__ + "static/media/hollow_bar_M1_tall.81cc0d24.svg";